export const CARRO = () => `/carro`;
export const CARROEDIT = () => `/carro/edit`;
export const CARROSUBSTITUIR = () => `/carro/substituir`;

